import { maxPrice, maxRooms, maxYield, maxArea } from './Constants'
import { numberWithCommas, SortTypes } from './index'

export const userDefault = {
  id: '',
  firstName: '',
  lastName: '',
  password: '',
  phoneNumber: '',
  address: '',
  gender: 'male',
  company: '',
  email: '',
  city: '',
  linkedinId: '',
  country: '',
  description: '',
  linkedinUrl: '',
  skypeName: '',
  hasFullAccess: true,
  picture: '',
  isActive: false,
  origin: '',
  ambassador: '',
  minInvestment: 0,
  maxInvestment: maxPrice,
  minNoRooms: 0,
  maxNoRooms: maxRooms,
  minYield: 0,
  maxYield: maxYield,
  minArea: 0,
  maxArea: maxArea,
  preferredCategories: [],
  preferredCities: [],
  preferredCountries: [],
  preferredRegions: [],
  recommendedBy: '',
  reasonHvbMember: ''
}

export const searchQueryDefault = {
  minInvestment: 0,
  maxInvestment: maxPrice,
  minNoRooms: 0,
  maxNoRooms: maxRooms,
  minYield: 0,
  maxYield: maxYield,
  preferredCategories: [],
  preferredCities: [],
  preferredCountries: [],
  preferredRegions: []
}

export const cityDefault = {
  city: '',
  country: '',
  picture: null,
  description: '',
  latlng: {
    lat: '',
    lng: ''
  }
}

export const continentDefault = {
  name: '',
  picture: null,
  description: ''
}

export const countryDefault = {
  name: '',
  continent: '',
  picture: null,
  description: ''
}

export const categoryDefault = {
  name: ''
}

export const adminDefault = {
  name: '',
  email: ''
}

export const tableKeysDefault = [
  {
    title: 'Title',
    key: 'title',
    width: 300,
    className: 'title',
    sort: null
  },
  {
    title: 'Continent',
    key: 'continent',
    width: 150,
    accessor: d => d.continent.name,
    sort: null
  },
  {
    title: 'Country',
    key: 'country',
    width: 150,
    accessor: d => d.country.name,
    sort: null
  },
  {
    title: 'City',
    key: 'city',
    width: 200,
    accessor: d => d.city.city,
    sort: null
  },
  {
    title: 'Category',
    key: 'category',
    width: 250,
    accessor: d => d.category.name,
    sort: null
  },
  {
    title: 'Keys',
    key: 'noRooms',
    width: 100,
    sort: null
  },
  {
    title: 'Portfolio',
    key: 'portfolio',
    width: 100,
    accessor: d => (d.portfolio ? 'Yes' : 'No'),
    sort: null
  },
  {
    title: 'Price',
    key: 'price',
    width: 100,
    unit: '€',
    accessor: d => numberWithCommas(d.price),
    sortAccessor: d => d.price,
    sort: null
  },
  {
    title: 'Yield',
    key: 'yield',
    width: 100,
    unit: '%',
    sort: null
  },
  {
    title: 'Area',
    key: 'area',
    width: 100,
    unit: 'm2',
    accessor: d => numberWithCommas(d.area),
    sortAccessor: d => d.area,
    sort: null
  }
]

export const propertyDefault = {
  area: '',
  category: null,
  city: null,
  continent: null,
  country: null,
  description: '',
  exclusivity: false,
  fullAccess: false,
  lead: '',
  noRooms: '',
  portfolio: false,
  price: '',
  realLocation: '',
  sold: false,
  title: '',
  usableArea: '',
  useDefaultPictures: false,
  usersFavorites: [],
  usersHaveAccess: [],
  published: false,
  picture: null,
  yield: '',
  latlng: null
}

export const preferenceDefault = {
  name: '',
  city: [],
  continent: [],
  country: [],
  category: [],
  minNoRooms: 0,
  maxNoRooms: maxRooms,
  minYield: 0,
  maxYield: maxYield,
  minPrice: 0,
  maxPrice: maxPrice,
  minArea: 0,
  maxArea: maxArea
}

export const sortOptionsDefault = [
  {
    label: 'Price Ascending',
    key: 'price',
    direction: SortTypes.ASC
  },
  {
    label: 'Price Descending',
    key: 'price',
    direction: SortTypes.DESC
  },
  {
    label: 'Yield Ascending',
    key: 'yield',
    direction: SortTypes.ASC
  },
  {
    label: 'Yield Descending',
    key: 'yield',
    direction: SortTypes.DESC
  },
  {
    label: 'Keys Ascending',
    key: 'noRooms',
    direction: SortTypes.ASC
  },
  {
    label: 'Keys Descending',
    key: 'noRooms',
    direction: SortTypes.DESC
  }
]



// WEBPACK FOOTER //
// ./src/Utils/Defaults.js